import * as monaco from 'monaco-editor'
import '../../bower_components/skulpt/skulpt.min.js'
import '../../bower_components/skulpt/skulpt-stdlib'

function builtinRead(x) {
    if (Sk.builtinFiles === undefined || Sk.builtinFiles["files"][x] === undefined)
            throw "File not found: '" + x + "'";
    return Sk.builtinFiles["files"][x];
}

export default {
    get exampleCode() {
        return `fruits = ["apple", "banana", "cherry"]
for x in fruits:
    print(x)`;
    },

    configure() {

    },

    async run (terminalBus, editor, code, showSuccess) {
        let hadOutput = false,
            outputCallback = _ => hadOutput = true;
        terminalBus.$on('writeOutput', outputCallback);
        Sk.configure({
            read: builtinRead,
            __future__: Sk.python3,
            output: payload => terminalBus.$emit('writeOutput', payload),
            inputfun: prompt => {
                return new Promise((resolve) => {
                    terminalBus.$emit('read', prompt)
                    terminalBus.$once('input', input => resolve(input))
                })
            },
            inputfunTakesPrompt: true
          })
    
          try {
            let result = await Sk.misceval.asyncToPromise(
              () => Sk.importMainWithBody('<stdin>', false, code, true)
            );
            if (!hadOutput) {
                terminalBus.$emit('writeOutput', '');
            }
            if (showSuccess) {
                terminalBus.$emit('writeMessage', '\x1B[1;3;32mProgram finished successfully\x1B[0m\n')
            }
          } catch (err) {
            monaco.editor.setModelMarkers(
              editor.getModel(),
              null,
              [{
                startLineNumber: err.traceback[0].lineno,
                startColumn: (err.traceback[0].colno || 0) + 1 || /[^\s]/.exec(this.getLine(code, err.traceback[0].lineno)).index + 1,
                endColumn: this.getLine(code, err.traceback[0].lineno).length + 1,
                endLineNumber: err.traceback[0].lineno,
                message: err.toString(),
                severity: 3
              }]
            )
            terminalBus.$emit('writeMessage', '\x1B[1;3;31mError: ' + err.toString() + '\x1B[0m\n')
          }
          terminalBus.$off('writeOutput', outputCallback);
    },

    async test (code, tests = [], inputs = []) {
        Sk.configure({
            read: builtinRead,
            __future__: Sk.python3,
            output: payload => {},
            inputfun: prompt => {
                return new Promise((resolve) => {
                    resolve(inputs.slice(0, 1))
                    inputs = inputs.slice(1)
                })
            },
            inputfunTakesPrompt: true
        })


        let finalPromise = Promise.all(
            [
                ...tests.map(test => ({...test, code: `${code}\n\n${test.code}\n\n__generatedValue=str(${test.valueGenerator})`}))
                    .map(async test => new Promise(
                            resolve => Sk.misceval.asyncToPromise(
                                () => Sk.importMainWithBody('<stdin>', false, test.code, true)
                            )
                            .then(res => {
                                let val = res.$d.__generatedValue.v;
                                if (res.$d.__generatedValue instanceof Sk.builtin.bool) {
                                    val = val ? 'True' : 'False';
                                }
                                resolve({ ...test, result: res.$d.testResult.v, generatedValue: val})
                            })
                            .catch(_ => resolve({ ...test, result: false, generatedValue: null}))
                    )),
            ]
        );

        return finalPromise;
    },
    getLine (code, number) {
        return code.split('\n')[number - 1]
    }
}
